import { csrfToken } from "./csrf";
import { convertKeysToSnakeCase } from "./convertKeysToSnakeCase";

type SendBeaconOptions = {
  snakeCase?: boolean;
};

export function sendBeaconData(
  url: string,
  data: Record<string, unknown>,
  options?: SendBeaconOptions,
): void {
  const transformedData = options?.snakeCase
    ? (convertKeysToSnakeCase(data) as Record<string, unknown>)
    : data;

  const payload = {
    ...transformedData,
    authenticity_token: csrfToken(),
  };

  const blob = new Blob([JSON.stringify(payload)], {
    type: "application/json",
  });

  navigator.sendBeacon(url, blob);
}
